import { Role } from "./role";
import { Contact } from "./contact";

export class User {

  constructor(
    public id?: number,
    public contactId: number = null,
    public contact: Contact = null,
    public email: string = null,
    public uid: string = null,
    public roles: string[] = [],
  ) {}

  public static initFromCurrentUserData(data: any): User {
    const user = new this()
    if (data.id) { user.id = data.id }
    if (data.contactId) { user.contactId = data.contactId }
    if (data.email) { user.email = data.email }
    if (data.uid) { user.uid = data.uid }
    if (data.roles) { user.roles = data.roles }

    return user
  }

  public static clone(obj: any): User {
    const user = new this()

    if (obj.id) { user.id = obj.id }
    if (obj.contactId) { user.id = obj.id }
    if (obj.contact) { user.contact = Contact.clone(obj.contact) }
    if (obj.email) { user.email = obj.email }
    if (obj.uid) { user.uid = obj.uid }
    if (obj.roles) { user.roles = obj.roles }

    return user
  }

  serializeForRails(): any {
    return {
      id: this.id,
      roles: this.roles,
    }
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/user.ts